import { useRef, useState } from "react";
import Modal from "../../../../parts/modal";
import ImageChatUploadInput from "../../../../parts/inputs/image-chat-upload";
import {
  parseAthletesOrganizationInfoToClientList,
  parseCoachInformationToChat,
} from "../../../../utils/user-helpers";
import getAvatarUrl from "../../../../utils/get-avatar-url";

export const NewGroupModalComponent = ({
  athletesToShow,
  usersOrganization,
  activeUser,
  referAsClients,
  allGroupChats,
}) => {
  const { webAppTheme = "dark" } = activeUser;
  const activeUserId = activeUser._id;
  const { organizationActiveUsers = [] } = usersOrganization || {};
  const referName = referAsClients ? "Client" : "Athlete";
  //array of coaches and athletes
  const allUsers = usersOrganization
    ? [
        ...organizationActiveUsers,
        ...parseAthletesOrganizationInfoToClientList(athletesToShow),
      ]
    : [
        ...parseCoachInformationToChat(activeUser),
        ...parseAthletesOrganizationInfoToClientList(athletesToShow),
      ];

  //store the participants
  const [participantState, setParticipantState] = useState([activeUserId]);
  //step 1 or 2
  const [stepState, setStepState] = useState(1);
  //send button action
  const createGroupButtonRef = useRef(null);

  /**
   * Select the participants
   * @param {*} value
   */
  const handleSelectionChange = (value) => {
    //active user is always selected
    if (String(value) !== String(activeUserId)) {
      let data = JSON.parse(JSON.stringify(participantState));
      if (!participantState.includes(value)) {
        //maximum 100 participants
        if (participantState.length < 100) {
          data.length === 1 && data[0].length === 0
            ? (data = [value])
            : data.push(value);
        }
      } else {
        if (participantState.length > 0) {
          const filtered = data.filter((val) => val != value);
          data = filtered.length > 0 ? filtered : [activeUserId];
        }
      }
      setParticipantState(data);
    }
  };

  /**
   * Set the step 2 or send the form
   * @returns
   */
  const handleNextStep = () => {
    if (stepState === 1) {
      if (participantState[0].length === 0) return;
      setStepState(2);
    } else {
      if (createGroupButtonRef.current) {
        createGroupButtonRef.current.click();
      }
    }
  };

  return (
    <Modal
      className={"create-chat-group-modal"}
      overflowModal={true}
      chatGroupEdit={true}
    >
      <div className="head border-divider">
        <h2 className="alt">New Group</h2>
        <a
          href={`/actions/refresh?groupParticipants=&groupSubject=&allGroupChats=&groupChatId=&groupImage=&groupEdited=&modal=`}
        >
          <img
            className="icon-red"
            src="/img/new-icons/red-cross.svg"
            alt="dismiss"
          />
        </a>
      </div>

      {stepState === 1 ? (
        <Step1NewGroup
          allUsers={allUsers}
          participantState={participantState}
          handleSelectionChange={handleSelectionChange}
          referName={referName}
          webAppTheme={webAppTheme}
        />
      ) : (
        <Step2NewGroup
          participantState={participantState}
          allUsers={allUsers}
          createGroupButtonRef={createGroupButtonRef}
          referName={referName}
          allGroupChats={allGroupChats}
          webAppTheme={webAppTheme}
        />
      )}
      <div className="modal-footer foot modal-footer-group-chat">
        <div className="footer-group-chat-modal">
          {stepState === 1 ? (
            <div>
              <button
                className="clear-all-group-chat"
                onClick={() => {
                  setParticipantState([activeUserId]);
                }}
              >
                Clear all
              </button>
            </div>
          ) : (
            <div>
              <button
                className="back-group-chat"
                onClick={() => {
                  setStepState(1);
                }}
              >
                Back
              </button>
            </div>
          )}
          <div>
            <button
              id="next-group-chat"
              data-button-type="primary"
              className="next-group-chat"
              onClick={handleNextStep}
              type={stepState === 1 ? "button" : "submit"}
            >
              <span>{stepState === 1 ? `Next` : `Create`}</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const Step1NewGroup = ({
  allUsers,
  participantState,
  handleSelectionChange,
  referName,
  webAppTheme,
}) => {
  //store the filter value
  const [filterValue, setFilterValue] = useState("");
  //array of filtered users
  const filteredUsers = filterValue
    ? allUsers.filter((user) =>
        user.name.toLowerCase().startsWith(filterValue.toLowerCase())
      )
    : allUsers;

  return (
    <div id="step-1-group-chat">
      <div className="step1-group-chat">
        <div className="search-user-group-chat">
          <input
            type="search"
            id="filter-group-chat"
            className="search-user-input-group-chat"
            placeholder="Search User"
            value={filterValue}
            onChange={({ target: { value } }) => setFilterValue(value)}
          />
        </div>
      </div>
      {filteredUsers.length === 0 && filterValue.length > 0 ? (
        <div className="empty-filter-chat-state">
          <p className="s1">No users with that name have been found</p>
        </div>
      ) : (
        <div className="gym-modal-main-table">
          <div className="add-participants-main-group-chat">
            <span className="add-participants-title-group-chat">
              Add Participants
            </span>
            <span className="add-participants-length-group-chat clipped">
              (
              {participantState.length && participantState[0].length === 0
                ? 0
                : participantState.length}
              )
            </span>
          </div>
          <div className="list-group-chat-participants-main">
            {filteredUsers.map((item) => {
              const { name = "", coachId = "", _id = "" } = item;

              return (
                <div
                  key={_id}
                  className="card-group-chat-participant"
                  onClick={() => handleSelectionChange(_id)}
                >
                  <div>
                    <div
                      className={
                        item.avatar && item.avatar.s3Path
                          ? "avatar-group-chat"
                          : "avatar-group-chat avatar-group-chat-border"
                      }
                      style={{
                        background: `url(${getAvatarUrl(
                          item,
                          false,
                          webAppTheme
                        )})`,
                        backgroundPosition: "center center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                      }}
                    ></div>
                    <div className="identifier-group-chat">
                      <span className="name-group-chat">{name}</span>
                      <span className="role-group-chat">
                        {coachId ? referName : "Coach"}
                      </span>
                    </div>
                  </div>
                  <div
                    className={
                      participantState.includes(_id)
                        ? "circle-selector-container-selected"
                        : "circle-selector-container"
                    }
                  >
                    <div
                      className={
                        participantState.includes(_id)
                          ? "radio radio-group-selected-group-chat"
                          : "radio-video-list"
                      }
                    >
                      {participantState.includes(_id) && (
                        <img
                          src="/img/new-icons/vuesax-linear-tick-circle-gradient.svg"
                          alt="checked"
                        />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

const Step2NewGroup = ({
  participantState,
  allUsers,
  createGroupButtonRef,
  referName,
  allGroupChats,
  webAppTheme,
}) => {
  //state to the form
  const [groupInformationState, setGroupInformationState] = useState({
    image: "",
    subject: "",
  });

  /**
   * Filter the participants getting all the user's information
   * @param {*} acc
   * @param {*} element
   * @returns
   */
  function filterParticipants(acc, element) {
    if (participantState.includes(element._id)) {
      acc.push(element);
    }
    return acc;
  }

  const selectedUsers = allUsers.reduce(filterParticipants, []);

  /**
   * Set the subject's value
   * @param {*} param0
   */
  const handleInputSubjectChange = ({ target }) => {
    const newState = Object.assign({}, groupInformationState, {
      [target.name]: target.value,
    });
    setGroupInformationState(newState);
  };

  return (
    <form
      encType="multipart/form-data"
      method="POST"
      data-noreset
      action={`/actions/chat/group-chat-save/`}
    >
      <div id="step-2-group-chat">
        <div className="step2-group-chat">
          <span className="add-participants-title-group-chat">
            Enter Group Subject and add a picture
          </span>
          <div className="image-name-group-chat">
            <ImageChatUploadInput
              name="image"
              prefix="Group chat"
              defaultValue={groupInformationState.image}
            />
            <div className="subject-group-chat">
              <input
                name="subject"
                className="search-user-input-group-chat"
                placeholder="Enter Group Subject"
                value={groupInformationState.subject}
                onChange={handleInputSubjectChange}
              />
              <input
                name="participants"
                defaultValue={JSON.stringify(selectedUsers)}
                type="hidden"
              />
              <input
                name="allGroupChats"
                defaultValue={allGroupChats}
                type="hidden"
              />
            </div>
          </div>
        </div>

        <div className="gym-modal-main-table">
          <div className="add-participants-main-group-chat">
            <span className="add-participants-title-group-chat">
              Participants : {selectedUsers.length} out of {allUsers.length}
            </span>
          </div>
          <div className="list-group-chat-participants-main">
            {selectedUsers.map((item) => {
              const { name = "", coachId = "", _id = "" } = item;

              return (
                <div key={_id} className="card-group-chat-participant">
                  <div>
                    <div
                      className={
                        item.avatar && item.avatar.s3Path
                          ? "avatar-group-chat"
                          : "avatar-group-chat avatar-group-chat-border"
                      }
                      style={{
                        background: `url(${getAvatarUrl(
                          item,
                          false,
                          webAppTheme
                        )})`,
                        backgroundPosition: "center center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                      }}
                    ></div>
                    <div className="identifier-group-chat">
                      <span className="name-group-chat">{name}</span>
                      <span className="role-group-chat">
                        {coachId ? referName : "Coach"}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <button
        id="create-group-button"
        ref={createGroupButtonRef}
        style={{ display: "none" }}
      ></button>
    </form>
  );
};
